import { render } from "./PublishConfigModal.vue?vue&type=template&id=b856995e&scoped=true"
import script from "./PublishConfigModal.vue?vue&type=script&lang=js"
export * from "./PublishConfigModal.vue?vue&type=script&lang=js"

import "./PublishConfigModal.vue?vue&type=style&index=0&id=b856995e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b856995e"]])

export default __exports__